import { MODULE_NAME as CAMPAIGNS_MODULE } from 'modules/campaigns/config/routes/module';
import { realtimeReportVisibilityCondition } from '../../../../../config/report-predicates/realtimeReportVisibilityCondition';
import {
    DATE,
    CVR,
    AVERAGE_CPC,
    CONVERSIONS,
    CONVERSIONS_CLICKS,
    CONVERSIONS_VIEWS,
    CVR_CLICKS,
    CVR_VIEWS,
} from '../../fields';
import { FILTER_TYPE } from '../../filters';
import { REPORT_PRESET } from '../../pickers';
import columnDefinitions from './columnDefinitions';
import footerColumnDefinitions from './footerColumnDefinitions';
import graph from './graph';
import { defaultColumns, customColumns } from './reportPresets';
import { TODAY_REPORT_ID } from './todayReportId';

export const todayRealtimeReportConfig = {
    id: TODAY_REPORT_ID,
    label: 'Today',
    permissions: ['TA_REAL_TIME_REPORT'],
    visibilityCondition: realtimeReportVisibilityCondition,
    module: CAMPAIGNS_MODULE,
    endpoint: 'realtime-campaign-report-by-hour-performance',
    graph,
    rowIdField: DATE.field,
    lastUpdateTimeField: DATE.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    footerColumnDef: footerColumnDefinitions,
    sortMap: {
        [DATE.field]: 'date',
        [CVR.field]: 'cpaConversionRate',
        [AVERAGE_CPC.field]: 'cpc',
        [CONVERSIONS.field]: 'cpaActionsNum',
        [CONVERSIONS_CLICKS.field]: 'cpaActionsNumFromClicks',
        [CONVERSIONS_VIEWS.field]: 'cpaActionsNumFromViews',
        [CVR_CLICKS.field]: 'cpaConversionRateClicks',
        [CVR_VIEWS.field]: 'cpaConversionRateViews',
    },
    customRestrictedFilters: {},
    filters: [
        {
            id: FILTER_TYPE.PLATFORM,
            permissions: ['TA_REAL_TIME_REPORT_FILTERS'],
        },
        {
            id: FILTER_TYPE.COUNTRY,
            permissions: ['TA_REAL_TIME_REPORT_FILTERS'],
        },
        {
            id: FILTER_TYPE.SITE,
            permissions: ['TA_REAL_TIME_REPORT_FILTERS'],
        },
    ],
};

export default todayRealtimeReportConfig;
